// Our actions follow FSA
// https://github.com/acdlite/flux-standard-action
import {REQUEST_QUIZ, RECEIVED_QUIZ,NOTRECEIVED_QUIZ ,RESET_QUIZ,SETUP_QUIZ,SELECT_NEXT, SELECT_BEFORE,GET_QUESTIONRESULT, SELECT_CHECK, SELECT_CHOICE, SHOW_VIDEO, HIDE_VIDEO, PLAY_VIDEO } from './ActionTypes'
import fetch from 'isomorphic-fetch' //Local. For node, https://github.com/matthew-andrews/isomorphic-fetch
//import { push } from 'react-router-redux'
//import { browserHistory } from 'react-router'
import {quiz_filename,quiz_url} from '../constants' // ga_ID
import ga from 'react-ga'

//fetching
export const requestQuiz=(quizID)=>({
  type: REQUEST_QUIZ,
  payload:{
      quizID: quizID
  }    
})
export const receivedQuiz=(quizID)=>({
  type: RECEIVED_QUIZ,
  payload:{
    quizID: quizID,
    receivedAt: Date.now() //Time Stamp          
  }
})
export const notreceivedQuiz=(quizID)=>({
  type: NOTRECEIVED_QUIZ,
  payload:{
    quizID: quizID,
    receivedAt: Date.now() //Time Stamp          
  }
})
//handling Quiz
export const resetQuiz=()=>({
  type: RESET_QUIZ,
  payload:{}
})
export const setupQuiz=(quizID,data)=>({
  type: SETUP_QUIZ,
  payload:{
    quizID,
    data,
    receivedAt: Date.now() //Time Stamp     
  }
})
//Routing
export const selectNext=(qnum)=>({
  type: SELECT_NEXT,
  payload:{
      qnum: qnum
  }    
})

export const selectBefore=(qnum)=>({
  type: SELECT_BEFORE,
  payload:{
      qnum: qnum
  }    
})
// MC Click actions
export const selectCheck=(qnum)=> ({
  type: SELECT_CHECK,
  payload:{
      qnum: qnum
  }    
})
export const playVideo=(qnum)=> ({
  type: PLAY_VIDEO,
  payload:{
      qnum: qnum,
  }    
})
// Not used.
export const getQuestionresult=(qnum)=> ({
  type: GET_QUESTIONRESULT,
  payload:{
      qnum: qnum
  }    
})

// thunk action creator for async fetch action.
export function fetchQuiz(quizID){
    return function(dispatch){
        dispatch(requestQuiz(quizID));// Action
        return fetch(quiz_url+quiz_filename,{cache: "no-cache"})// quiz file
          .then(response => response.json())
          .then(json=>{
              var data=json[quizID] //super inefficient!
              if(typeof data === 'undefined' || data.length === 0){ //Nothing or empty.
                dispatch(notreceivedQuiz(quizID));
              }
              else{
                dispatch(receivedQuiz(quizID));
                dispatch(setupQuiz(quizID,data));
              }
            }
          )
        //Error handling later.
    }
}
// 20160525 - We will make a thunk action creator to report score info into g-analytics 
// it will get the current state.
// https://github.com/reactjs/react-redux/issues/102
export function reportCheck(qnum){
  return function(dispatch,getState){
    dispatch(selectCheck(qnum));
    const {quiz} = getState();
    const correct= quiz.result[qnum].correct === true ? 1:0;
    const select= quiz.result[qnum].select || '0';
    const qID=quiz.data[qnum].ID;
    // Report to google analytics
    ga.event({
      category: qID,
      action: select,
      label: qID,
      value: correct
    });
    //console.log('ga event!');
  };
}
export function reportVideo(qnum){
  return function(dispatch, getState){
    const { quiz } = getState();
    const { play } = quiz.result[qnum];
    // Report to google analytics
    if(play === null ){
      const qID = quiz.data[qnum].ID;
      ga.event({
        category: 'Video',
        action: qID,
        label:'V'+qID,
        value:1
      });
      dispatch(playVideo(qnum));
      //console.log('ga event! report video');
    }
  }
}
export const selectChoice=(qnum,cID)=> ({
  type: SELECT_CHOICE,
  payload:{
      qnum: qnum,
      cID: cID
  }    
})
export const showVideo=()=> ({
  type: SHOW_VIDEO,
  payload:{}    
})
export const hideVideo=()=> ({
  type: HIDE_VIDEO,
  payload:{}    
})



// WEBPACK FOOTER //
// ./src/actions/index.js